import {
  CLOSE_EMAIL_COLLECTOR_DIALOG,
  EmailCollectorActions,
  OPEN_EMAIL_COLLECTOR_DIALOG,
} from './actions';

export type EmailCollector = {
  show: boolean;
};

const initialState: EmailCollector = {
  show: false,
};

const emailCollectorDialog = (
  state = initialState,
  action: EmailCollectorActions,
): EmailCollector => {
  switch (action.type) {
    case OPEN_EMAIL_COLLECTOR_DIALOG:
      return {
        ...state,
        show: true,
      };

    case CLOSE_EMAIL_COLLECTOR_DIALOG:
      return {
        ...state,
        show: false,
      };

    default:
      return state;
  }
};

export default emailCollectorDialog;
